/* Rotating text */
var TxtType = function(el, toRotate, period) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = '';
    this.tick();
    this.isDeleting = false;
};

TxtType.prototype.tick = function() {
    var i = this.loopNum % this.toRotate.length;
    var fullTxt = this.toRotate[i];

    if (this.isDeleting) {
    this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
    this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

    var that = this;
    var delta = 200 - Math.random() * 100;

    if (this.isDeleting) { delta /= 2; }

    if (!this.isDeleting && this.txt === fullTxt) {
    delta = this.period;
    this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
    this.isDeleting = false;
    this.loopNum++;
    delta = 500;
    }

    setTimeout(function() {
    that.tick();
    }, delta);
};

window.onload = function() {
    var elements = document.getElementsByClassName('typewrite');
    for (var i=0; i<elements.length; i++) {
        var toRotate = elements[i].getAttribute('data-type');
        var period = elements[i].getAttribute('data-period');
        if (toRotate) {
          new TxtType(elements[i], JSON.parse(toRotate), period);
        }
    }
    // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #D3D3D3;}";
    document.body.appendChild(css);
};



/* APPEAR ANIMATION */
(function($) {
  $.fn.visible = function(partial) {
      var $t            = $(this),
          $w            = $(window),
          $wh           = $(window).height() - 100,
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $wh,
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };
})(jQuery);

var win = $(window);
var allMods = $(".module");

allMods.each(function(i, el) {
  var el = $(el);
  if (el.visible(true)) {el.addClass("already-visible");} 
});

win.scroll(function(event) {
  allMods.each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {el.addClass("come-in");} 
  });
});



/* table of content articles */
$(document).ready(function() {
  const $toc = $("#toc");
  const $content = $(".articleBody");

  // Early return if TOC or content element doesn't exist
  if (!$toc.length || !$content.length) return;

  const $headings = $content.find("h1, h2, h3");
  
  // If no headings, do nothing
  if (!$headings.length) return;

  // Generate table of contents
  $headings.each(function(index) {
    const $heading = $(this);
    const text = $heading.text().trim();
    
    // Skip if heading text is empty
    if (!text) return;

    // Ensure each heading has a unique ID
    let id = $heading.attr("id");
    if (!id) {
      id = `heading-${index}`;
      $heading.attr("id", id);
    }

    // Determine heading level for indentation
    const level = parseInt($heading.prop("tagName").substring(1));
    
    // Create list item with link
    const $listItem = $("<li>")
      .addClass(`toc-level-${level}`)
      .append(`<a href="#${id}">${text}</a>`);

    $toc.append($listItem);
  });
});

/* accordion toggle */
$(document).ready(function () {
  $('.accordion__disclosure').on('toggle', function () {
    const $this = $(this);

    if ($this.prop('open')) {
      // Close all other accordions
      $('.accordion__disclosure').not(this).each(function () {
        $(this).removeAttr('open').attr('aria-expanded', 'false');
      });

      // Set this one as expanded
      $this.attr('aria-expanded', 'true');
    } else {
      // If it's being closed, update its aria too
      $this.attr('aria-expanded', 'false');
    }
  });
});

/* product read more */
$(document).ready(function () {
  var $description = $('.product-info__block-item[data-block-type="description"] .prose');

  if ($description.length === 0) return;
  if ($(window).width() > 768) return; // Only apply on mobile

  var maxHeight = 78; // px

  if ($description[0].scrollHeight > maxHeight) {
    $description.addClass('truncated-description');

    var $btn = $('<button/>', {
      text: '... Voir plus',
      class: 'read-more-toggle'
    });

    $description.parent().append($btn);

    $btn.on('click', function () {
      $description.toggleClass('open');
      $btn.toggleClass('open');

      var isOpen = $description.hasClass('open');
      $btn.text(isOpen ? 'Voir moins' : '... Voir plus');
    });
  }
});